import { PICKUP_DROP_OPTIONS } from "../../lib/journey";
import { chipCls } from "../booking/WizardParts";

// Pick & drop or self visit, chosen when the car is booked. Two pills rather
// than a dropdown: it is one tap, and both answers stay in view.
export function PickupDropChoice({ value, onChange, testid = "pickup-drop-choice" }) {
  return (
    <div role="radiogroup" aria-label="Pick & drop" className="flex flex-wrap gap-2" data-testid={testid}>
      {PICKUP_DROP_OPTIONS.map(([key, label]) => {
        const on = value === key;
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={on}
            data-testid={`${testid}-${key === "Self Visit" ? "self" : "pickup"}`}
            onClick={() => onChange(key)}
            className={chipCls(on)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
